export enum CancellationReason {
  unexpectedEvent = 'unexpected_event',
  inconvenientLocation = 'inconvenient_location',
  foundAnotherAsset = 'found_another_asset',
  somethingOff = 'something_off',
  partnerRoommate = 'partner_roommate',
}

export const CancellationReasonLabel: any = {
  [CancellationReason.unexpectedEvent]: 'J’ai un imprévu qui m’empêche de me rendre à la visite',
  [CancellationReason.inconvenientLocation]: 'La localisation précise du bien ne me convient pas',
  [CancellationReason.foundAnotherAsset]: 'J’ai trouvé mon bonheur ailleurs',
  [CancellationReason.somethingOff]:
    'Un aspect du bien est bloquant (étage, bruit, orientation, etc.)',
  [CancellationReason.partnerRoommate]: 'Ce bien ne plaît pas au partenaire/colocataire',
}
